// Catálogo de vídeos de treinamento (extraído do PDF "Canal Golive_Youtube_r10.pdf").
// Mesma fonte de dados usada no catálogo equivalente do LiveDesk.
const videoCatalog = [
  {
    playlist: "Dados Mestres",
    slug: "dados-mestres",
    topics: [
      { text: "Cadastro de Plano de contas", videoLink: "https://youtu.be/XnKlXl7PpSU" },
      { text: "Cadastro de Itens (produtos)", videoLink: "https://youtu.be/OV-hwMtjcE4" },
      { text: "Cadastro de Parceiros de Negócios", videoLink: "https://youtu.be/D6NvAf4UUig" },
      { text: "Cadastro de Depósitos", videoLink: "https://youtu.be/HseeiHNljqQ" },
      { text: "Cadastro de Usuários", videoLink: "https://youtu.be/2ZmS5fPAqzc" },
      { text: "Cadastro de Filiais", videoLink: "https://youtu.be/ASEvbqUHCiE" },
      { text: "Cadastro de Forma de Pagamento", videoLink: "https://youtu.be/DyPnTivuEpM" },
      { text: "Cadastro de Utilização", videoLink: "https://youtu.be/RPDMiK5PzQg" },
      { text: "Grupo de Itens", videoLink: "https://youtu.be/J_TX8i6Pm14" },
      { text: "Cadastro de Bancos", videoLink: "https://youtu.be/OnVBupJOJUI" },
      { text: "Cadastro de Condições de Pagamento", videoLink: "https://youtu.be/_BzoTaU6xP4" },
      { text: "Cadastro de Código de Imposto", videoLink: "https://youtu.be/MyNKISJAu18" },
      { text: "Cadastro de Dimensões", videoLink: "https://youtu.be/sKkC65mf3rI" },
      { text: "Cadastro de Regras de Distribuição", videoLink: "https://youtu.be/PKhjog_Uhl0" },
      { text: "Cadastro de Unidade de Medida", videoLink: "https://youtu.be/SO2dniigkQQ" },
      { text: "Cadastro de Vendedores/Compradores", videoLink: "https://youtu.be/SuqlUOQqyIk" },
    ],
  },
  {
    playlist: "Compras",
    slug: "compras",
    topics: [
      { text: "Contrato Guarda-Chuva Compras", videoLink: "https://youtu.be/AqU7EpGE_S4" },
      { text: "Solicitação de Compras", videoLink: "https://youtu.be/edC3_lQuPn8" },
      { text: "Cotação de Compras", videoLink: "https://youtu.be/X8bWijX4zgA" },
      { text: "Pedido de Compras", videoLink: "https://youtu.be/LjORmnhK7t8" },
      { text: "Recebimento e Devolução", videoLink: "https://youtu.be/bzVtqSsdt5M" },
      { text: "Documento de Entrada", videoLink: "https://youtu.be/5_XvqRgblSI" },
      { text: "Devolução Documento de Entrada", videoLink: "https://youtu.be/Di9IESEwaj0" },
      { text: "Autorização de Documentos", videoLink: "https://youtu.be/pvXEUcBC_Qo" },
      { text: "Lista de Preços", videoLink: "https://youtu.be/XmStX9NbKXs" },
      { text: "TaxPlus – Importação XMLs", videoLink: "https://youtu.be/TFIR62z_Jec" },
      { text: "Despesas Adicionais", videoLink: "https://youtu.be/XAmd-JuI4Dc" },
      { text: "TaxPlus – Manifesto MDF-e", videoLink: "https://youtu.be/3hBd0jtRDVI" },
      { text: "Despesas Importação", videoLink: "https://youtu.be/jwiplEHauEw" },
      { text: "Recebimento Futuro", videoLink: "https://youtu.be/dVLm3igb1tY" },
      { text: "Catálogo Parceiro de Negócios", videoLink: "https://youtu.be/aW6ZlI_4SEg" },
    ],
  },
  {
    playlist: "Vendas",
    slug: "vendas",
    topics: [
      { text: "Contrato Guarda Chuva", videoLink: "https://youtu.be/fjpQvL4I370" },
      { text: "Oportunidade de Vendas", videoLink: "https://youtu.be/4M8ky63PRAE" },
      { text: "Cotação de Vendas", videoLink: "https://youtu.be/49zMWN1YOnY" },
      { text: "Pedido de Vendas", videoLink: "https://youtu.be/hy4oQLwBOP4" },
      { text: "Assistente de Geração de Documentos", videoLink: "https://youtu.be/KlzP9iNH6BY" },
      { text: "Comissão de Vendas", videoLink: "https://youtu.be/IniddOH_v2o" },
      { text: "Nota de Saída", videoLink: "https://youtu.be/S-iNaMIDDe8" },
      { text: "TaxPlus – NF-e", videoLink: "https://youtu.be/rqqdcSK3n-w" },
      { text: "TaxPlus – NFS-e", videoLink: "https://youtu.be/5bEaaq94eNY" },
      { text: "Devolução de Nota Fiscal", videoLink: "https://youtu.be/erACbzkUNPU" },
      { text: "Nota Entrega Futura", videoLink: "https://youtu.be/a9WE4YC16NY" },
    ],
  },
  {
    playlist: "Estoque",
    slug: "estoque",
    topics: [
      { text: "Entrada de itens em estoque", videoLink: "https://youtu.be/NP6AcXzgijs" },
      { text: "Baixa itens estoque", videoLink: "https://youtu.be/NP6AcXzgijs" },
      { text: "Inventário", videoLink: "https://youtu.be/oeyAnc-D7Ec" },
      { text: "Picking", videoLink: "https://youtu.be/m7fxEd-YSbU" },
      { text: "Administração Número Série e Lote", videoLink: "https://youtu.be/8WuIh_AAGqM" },
      { text: "MRP", videoLink: "https://youtu.be/BKTZla9AihM" },
      { text: "Relatórios Estoque", videoLink: "https://youtu.be/OCaqzW5TEWI" },
      { text: "Posições do Depósito", videoLink: "https://youtu.be/2oiYzy9h-04" },
    ],
  },
  {
    playlist: "Financeiro",
    slug: "financeiro",
    topics: [
      { text: "Adiantamento de Clientes", videoLink: "https://youtu.be/TrqOW1VWgY0" },
      { text: "Adiantamento de Fornecedores", videoLink: "https://youtu.be/knNZ_bPJpE8" },
      { text: "Lançamentos Recorrentes", videoLink: "https://youtu.be/Ml1bHqAX13g" },
      { text: "Transações Recorrentes", videoLink: "https://youtu.be/Ml1bHqAX13g" },
      { text: "Contas a pagar", videoLink: "https://youtu.be/jdr-gKsiRyo" },
      { text: "Contas a receber", videoLink: "https://youtu.be/eXMhv3bEpAM" },
      { text: "Baixa manual contas a pagar", videoLink: "https://youtu.be/BIpi0X_i5zc" },
      { text: "Baixa manual contas a receber", videoLink: "https://youtu.be/wNgplRi0BrI" },
      { text: "Reconciliação manual", videoLink: "https://youtu.be/Z9PEe5AHWM4" },
      { text: "BankPlus – Reconciliação", videoLink: "https://youtu.be/s0DY_7AyNdk" },
      { text: "BankPlus – CNAB Pagar", videoLink: "https://youtu.be/deiM7mgYBy4" },
      { text: "BankPlus – CNAB Receber", videoLink: "https://youtu.be/cIKk5KemvJk" },
      { text: "BankPlus – Renegociação", videoLink: "https://youtu.be/XWqw_qqXBmc" },
      { text: "BankPlus - DDA", videoLink: "https://youtu.be/P7eutWyBJe0" },
      { text: "Pagamento via cartão de crédito", videoLink: "https://youtu.be/X7yZH7dzPKU" },
      { text: "Controle de cheques", videoLink: "https://youtu.be/HGWMI67MVuU" },
      { text: "Descontos e Feriados", videoLink: "https://youtu.be/NP0QacvWzIY" },
      { text: "Assistente de Pagamentos", videoLink: "https://youtu.be/QYQbaoUfIx4" },
      { text: "Relatórios Financeiros", videoLink: "https://youtu.be/fUp2J5ZCLWE" },
      { text: "Fluxo de Caixa", videoLink: "https://youtu.be/PVX5Xhqb-60" },
    ],
  },
  {
    playlist: "Contabilidade",
    slug: "contabilidade",
    topics: [
      { text: "Períodos Contábeis", videoLink: "https://youtu.be/qsAr6HsOVaQ" },
      { text: "Lançamento Contábil Manual", videoLink: "https://youtu.be/G5EqIrx80jQ" },
      { text: "Determinação Contábil", videoLink: "https://youtu.be/d3JKSQZsFCA" },
      { text: "Conciliação Contas Contábeis", videoLink: "https://youtu.be/dV6fx434aJI" },
      { text: "Reclassificação Contábil", videoLink: "https://youtu.be/14ECgn6uzTI" },
      { text: "Definição de Orçamento", videoLink: "https://youtu.be/bnUhj8_c8cE" },
      { text: "Cenário de Orçamento", videoLink: "https://youtu.be/YuTELKu4HeY" },
      { text: "Relatórios de Orçamento", videoLink: "https://youtu.be/1TtBKOMzW4M" },
      { text: "ECD", videoLink: "https://youtu.be/en5kdcqY8xE" },
      { text: "ECF", videoLink: "https://youtu.be/VStg_p8zcwY" },
      { text: "Relatórios Contábeis", videoLink: "https://youtu.be/q1Rjspw70tU" },
      { text: "Bloqueio Encerramento Período", videoLink: "https://youtu.be/FWwMucxAUUk" },
    ],
  },
  {
    playlist: "Fiscal",
    slug: "fiscal",
    topics: [
      { text: "Determinação Fiscal", videoLink: "https://youtu.be/0tkXVhIl07Y" },
      { text: "Código Benefícios Fiscais", videoLink: "https://youtu.be/jFm7QdK9ios" },
      { text: "Apuração Impostos", videoLink: "https://youtu.be/jLvnFRYJTxY" },
      { text: "Apuração CIAP", videoLink: "https://youtu.be/72Bz0mw9O6w" },
      { text: "DIRF", videoLink: "https://youtu.be/bwB0JSoSBCo" },
      { text: "REINF", videoLink: "https://youtu.be/69Mxt_CUfDg" },
      { text: "DCTF", videoLink: "https://youtu.be/DuaSuQDDuro" },
      { text: "GNRE", videoLink: "https://youtu.be/ubHwG58Yf8Y" },
      { text: "SPED Fiscal (ICMS e IPI)", videoLink: "https://youtu.be/7-eg_mLWZG4" },
      { text: "SPED Contribuições", videoLink: "https://youtu.be/qmueOM5R_lc" },
      { text: "Relatórios Fiscais", videoLink: "https://youtu.be/r5iOnYkqC7A" },
      { text: "Impostos Retidos", videoLink: "https://youtu.be/I4EnoUiqU4c" },
    ],
  },
  {
    playlist: "Produção",
    slug: "producao",
    topics: [
      { text: "Estrutura de Produtos", videoLink: "https://youtu.be/T7BoGobF0-Y" },
      { text: "Ordem de Produção", videoLink: "https://youtu.be/C-KEidh6SfU" },
      { text: "Saída de Insumos", videoLink: "https://youtu.be/g3syxf7Zxcc" },
      { text: "Entrada de Produto acabado", videoLink: "https://youtu.be/Tmr6otE2YiE" },
      { text: "Ordem de desmontagem", videoLink: "https://youtu.be/oM-D8mQI-fQ" },
    ],
  },
  {
    playlist: "Serviços",
    slug: "servicos",
    topics: [
      { text: "Cartão de Equipamentos", videoLink: "https://youtu.be/Zko29GP1l88" },
      { text: "Contrato de Serviços", videoLink: "https://youtu.be/FMQhMMNWtAs" },
      { text: "Projetos Financeiros", videoLink: "https://youtu.be/pVGOq28yTjI" },
      { text: "Projeto", videoLink: "https://youtu.be/9-EeGXLwtsg" },
      { text: "Tarefa de Projetos", videoLink: "https://youtu.be/wNfuBzrEb6U" },
      { text: "Ordem de Produção x Projetos", videoLink: "https://youtu.be/zUdAbXEtXT8" },
      { text: "Documentos x Projetos", videoLink: "https://youtu.be/a1_CvJYSCCs" },
      { text: "Medição de Projetos", videoLink: "https://youtu.be/ZVto4d6295E" },
    ],
  },
  {
    playlist: "Projetos",
    slug: "projetos",
    topics: [
      { text: "Relatório de Projetos", videoLink: "https://youtu.be/p29Jmb9636A" },
    ],
  },
];

export default videoCatalog;